<div class="card flex justify-content-center">
  <p-progressSpinner ariaLabel="loading" />
</div>
